/**
 * Renders the dialog requested through `utils/confirm`. Mounted once, in the
 * shell.
 */

import { TriangleAlert } from 'lucide-react'
import { useSyncExternalStore } from 'react'

import { getPendingConfirm, settleConfirm, subscribeConfirm } from '../../utils/confirm'
import Button from './Button'
import Modal from './Modal'

export default function ConfirmHost() {
    const request = useSyncExternalStore(subscribeConfirm, getPendingConfirm, getPendingConfirm)
    const danger = request?.tone === 'danger'
    return (
        <Modal
            open={request !== null}
            onClose={() => settleConfirm(false)}
            title={request?.title ?? ''}
            icon={TriangleAlert}
            size="sm"
            footer={
                <>
                    <Button variant="ghost" onClick={() => settleConfirm(false)}>
                        {request?.cancelLabel ?? 'Abbrechen'}
                    </Button>
                    <Button variant={danger ? 'danger' : 'primary'} onClick={() => settleConfirm(true)}>
                        {request?.confirmLabel ?? 'Fortfahren'}
                    </Button>
                </>
            }
        >
            <p className="whitespace-pre-line text-sm text-fg">{request?.message}</p>
        </Modal>
    )
}
